import { Route, Routes } from "react-router-dom"
import NotFound from "../components/NotFound"
import MapView from "../pages/Home/MapView"
import MainPMV from "../pages/PMV/Index"
import MainCCTV from "../pages/CCTV/Index"
import ListPMV from "../pages/PMV/ListPMV"
import AlarmManagement from "../pages/AlarmManagement/Index"
import IncidentManagement from "../pages/IncidentManagement/Index"
import TrendGraphManagement from "../pages/TrendGraphManagement/Index"
import TurnoManagement from "../pages/TurnoManagement/Index"
import ReportDownload from "../pages/ReportDownload/Index"
import SignalPlanManagement from "../pages/SignalPlanManagement/Index"
import InventoryMain from "../pages/Inventory/Index"
import { RequireAuth } from "./RequireAuth"
import ModalLogin from "../pages/Login/Modal"
import WeatherStation from "pages/WeatherStation/Index"
import IndexETD from "pages/ETD/Index"
import MainSOS from "pages/SOS/Index"

const RoutesComp: React.FC = () => {
    return (
        <Routes>
            {/* Login */}
            <Route path="/login" element={<ModalLogin />} />
            {/* Vista principal */}
            <Route path="/" element={<RequireAuth><MapView /></RequireAuth>} />

            {/* Victa principal de CCTV */}
            <Route path="/cctv/:encryptedId" element={<RequireAuth><MainCCTV /></RequireAuth>} />

            {/* Vista principal de PMV */}
            <Route path="/pmv/:encryptedId" element={<RequireAuth><MainPMV /></RequireAuth>} />

            {/* Vista principal de SOS */}
            {/* <Route path="/sos/:encryptedId" element={<RequireAuth><MainSOS /></RequireAuth>} /> */}
            <Route path="/sos" element={<RequireAuth><MainSOS /></RequireAuth>} />

            {/* Vista principal de estación meteorológica */}
            <Route path="/weather-station/:encryptedId" element={<RequireAuth><WeatherStation /></RequireAuth>} />

            {/* Vista principal de ETD */}
            <Route path="/etd/:encryptedId" element={<RequireAuth><IndexETD /></RequireAuth>} />

            {/* Vista de todos los paneles de mensaje variable */}
            <Route path="/pmv-all" element={<RequireAuth><ListPMV /></RequireAuth>} />

            {/* Gestión de alarmas */}
            <Route path="/gestion-alarmas" element={<RequireAuth><AlarmManagement /></RequireAuth>} />

            {/* Gestión de incidentes */}
            <Route path="/gestion-incidentes" element={<RequireAuth><IncidentManagement /></RequireAuth>} />

            {/* Gráficos de endencia */}
            <Route path="/graficos-tendencia" element={<RequireAuth><TrendGraphManagement /></RequireAuth>} />

            {/* Gestión de Turnos */}
            <Route path="/gestion-turnos" element={<RequireAuth><TurnoManagement /></RequireAuth>} />

            {/* Reportes */}
            <Route path="/reportes" element={<RequireAuth><ReportDownload /></RequireAuth>} />

            {/* Reportes */}
            <Route path="/inventario" element={<RequireAuth><InventoryMain /></RequireAuth>} />

            {/* Planes de señalización */}
            <Route path="/planes-señalizacion" element={<RequireAuth><SignalPlanManagement /></RequireAuth>} />

            {/* Ruta para manejar todas las rutas no definidas */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    )
}

export default RoutesComp